import { createReducer } from '@reduxjs/toolkit'

import { InternalApiKeysActions } from './actions'
import type { ApiKeysState } from './types'

const initial: ApiKeysState = {
  list: [],
  error: false,
}

export const apiKeysReducer = createReducer(initial, (builder) => {
  builder
    .addCase(InternalApiKeysActions.set, (state, { payload }) => ({
      ...state,
      list: payload,
      error: false,
    }))
    .addCase(InternalApiKeysActions.remove, (state, { payload }) => ({
      ...state,
      list: state.list.filter((key) => key.id !== payload),
    }))
    .addCase(InternalApiKeysActions.setError, (state, { payload }) => ({
      ...state,
      error: payload,
    }))
})
